module.exports = __webpack_public_path__ + "assets/img/成功.e7b6419d.png";